Init:
  post:
    operationId: postInit
    tags:
      - SSO
    summary: アクセスキーの取得
    description: |
      ### IdPのログイン画面にアクセスするために必要なkeyを発行します。
      
      SSO連携では、専用のアクセスキーを発行することで、 IdPのログイン画面にアクセスできます。
      
      > 💡 &nbsp; **Note**  <br><br>
      ・事前に、管理ページ「ユーザー」⇒「SSO連携」メニューの「SAML」にて、任意のIdPと連携を行う必要があります。<br>
      ・管理ページ「共有」⇒「カスタム設定」メニューの「DirectCloud API」にて、「使用する」を選択することで、APIキー(Service、Service Key)を取得できます。

    requestBody:
      $ref: "../openapi/requests.yaml#/SSOInitRequest"

    responses:
      "200":
        description: key発行成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/SSOInit"
      "default":
        description: key発行失敗
        content:
          application/json:
            examples:
              SSOError:
                $ref: "../openapi/response.error.yaml#/SSOError"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionsso"

Login:
  parameters:
    - $ref: "../parameters.yaml#/QuerySSOKey"
  get:
    operationId: getLogin
    tags:
      - SSO
    summary: IdPのログイン画面の表示
    description: |
      ### IdPのログイン画面にアクセスします。
      
      管理ページにて連携したIdPのログイン画面にアクセスします。
    responses:
      "302":
        description: ログインページに移動
      "default":
        description: IdPのログイン画面表示の権限がない場合
        content:
          application/json:
            examples:
              ㅤ:
                $ref: "../openapi/response.error.yaml#/InputValueSSO"

Status:
  parameters:
    - $ref: "../parameters.yaml#/QuerySSOKey"
  get:
    operationId: getStatus
    tags:
      - SSO
    summary: 認証情報の照会
    description: |
      ### SSO連携の認証情報を照会します。

      `status`は認証情報の識別コードです。
      - 1: 未認証
      - 2: 認証済
      - 3: アクセストークンの有効期限切れ、アクセストークンの破棄
    responses:
      "200":
        description: 照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/SSOStatus"
      "default":
        description: 照会失敗
        content:
          application/json:
            examples:
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              SSOStatusError1:
                $ref: "../openapi/response.error.yaml#/SSOStatusError1"
              SSOStatusError3:
                $ref: "../openapi/response.error.yaml#/SSOStatusError3"

